import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  value: string;
  disabled?: boolean;
  onChange?:
    | ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void)
    | undefined;
}

export const WeekdaySelect: React.FC<IProps> = memo(({ value, disabled = false, onChange }) => {
  return (
    <Select disabled={disabled} value={value} style={{ width: 140 }} onChange={onChange}>
      <Option value="Monday">{L('Monday')}</Option>
      <Option value="Tuesday">{L('Tuesday')}</Option>
      <Option value="Wednesday">{L('Wednesday')}</Option>
      <Option value="Thursday">{L('Thursday')}</Option>
      <Option value="Friday">{L('Friday')}</Option>
      <Option value="Saturday">{L('Saturday')}</Option>
      <Option value="Sunday">{L('Sunday')}</Option>
    </Select>
  );
});
